import React from 'react'
import icon from './svgs/certificateTick.svg'
import { BaseIcon } from './_base'

export const CertificateTickIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon = {icon} {...{fontSize,size,...sx}} />
    )
}
